export default function filterItemCriteriaIfExistsInPostalOperators(
  items,
  postalOperators,
) {
  const result = [];
  if (!postalOperators || postalOperators.length === 0) {
    return [...items];
  }

  const addIfExists = (itemCode) => {
    if (items.includes(itemCode)) {
      result.push(itemCode);
    }
  };

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < postalOperators.length; index++) {
    const postalOperator = postalOperators[index];
    addIfExists(postalOperator.value);
  }

  return result;
}
